<template>
  <Transition name="aub">
    <div v-if="visible" class="aub" role="status" aria-live="polite">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
      </svg>
      <span class="aub-text">Saiu uma versão nova do WootDash.</span>
      <button type="button" class="aub-apply" :disabled="applying" @click="apply">{{ applying ? 'Atualizando…' : 'Atualizar agora' }}</button>
      <button type="button" class="aub-later" @click="dismissed = true">Depois</button>
    </div>
  </Transition>
</template>

<script setup lang="ts">
// Avisa que há deploy novo enquanto o app está aberto (substitui o botão "Atualizar" do cabeçalho). A conferência é
// feita quando a aba volta a ficar visível e quando a conexão em tempo real volta — sem polling. "Depois" esconde até
// o próximo carregamento; a versão nova entra de qualquer jeito no próximo recarregar/login.
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { appUpdateAvailable, applyAppUpdate, checkForAppUpdate } from '@/composables/useAppUpdate'
import { onRealtimeRecovered } from '@/composables/useConversationRealtime'

const store = useStore()
const dismissed = ref(false)
const applying = ref(false)
const visible = computed(() => appUpdateAvailable.value && !dismissed.value && !!store.getters.isLoggedIn)

function apply() {
  applying.value = true
  void applyAppUpdate()
}

function onVisible() {
  if (document.visibilityState === 'visible') void checkForAppUpdate()
}

let stopRecovered: (() => void) | null = null
onMounted(() => {
  document.addEventListener('visibilitychange', onVisible)
  stopRecovered = onRealtimeRecovered(() => { void checkForAppUpdate() })
})
onBeforeUnmount(() => {
  document.removeEventListener('visibilitychange', onVisible)
  stopRecovered?.()
})
</script>

<style scoped>
.aub { position: fixed; left: 50%; bottom: 20px; transform: translateX(-50%); z-index: 900; display: flex; align-items: center; gap: 10px;
  padding: 10px 12px 10px 16px; border-radius: 12px; background: var(--night, #021627); color: #fff; box-shadow: 0 10px 32px rgba(2,22,39,.35);
  font-size: 13px; max-width: calc(100vw - 32px); }
.aub svg { color: #7dd3fc; flex-shrink: 0; }
.aub-text { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.aub-apply { border: none; border-radius: 8px; padding: 7px 12px; background: var(--red, #bc0c24); color: #fff; font: 600 12.5px inherit; cursor: pointer; white-space: nowrap; }
.aub-apply:hover:not(:disabled) { background: var(--red-dark, #73010f); }
.aub-apply:disabled { opacity: .7; cursor: progress; }
.aub-later { border: none; background: none; color: rgba(255,255,255,.7); font: 500 12.5px inherit; cursor: pointer; padding: 7px 6px; }
.aub-later:hover { color: #fff; }
.aub-enter-active, .aub-leave-active { transition: opacity .25s ease, transform .25s ease; }
.aub-enter-from, .aub-leave-to { opacity: 0; transform: translate(-50%, 12px); }
@media (max-width: 520px) { .aub-text { white-space: normal; } }
</style>
